import {
  SET_HOME_NAV_MOUNTED,
  SET_MAIN_NAV_MOUNTED,
  SET_CURRENT_ROUTE_NAME,
} from "../reducers/actionTypes";

const initialState = {
  isHomeNavMounted: false,
  isMainNavMounted: false,
  currentRouteName: "",
};

export const actions = {
  setCurrentRouteName: (routeName = "") => ({
    type: SET_CURRENT_ROUTE_NAME,
    routeName,
  }),
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_HOME_NAV_MOUNTED: {
      return {
        ...state,
        isHomeNavMounted: action.mounted,
      };
    }
    case SET_MAIN_NAV_MOUNTED: {
      return {
        ...state,
        isMainNavMounted: action.mounted,
      };
    }

    case SET_CURRENT_ROUTE_NAME:
      return {
        ...state,
        currentRouteName: action.routeName,
      };
    default:
      return state;
  }
}
reducer.initialState = initialState;

export default reducer;
